import CONSTANTS from '../constants'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
    loader: false,
    hasError: false,
    warnCitationDetail: EMPTY_OBJECT,
    errorMessage: '',
    facilityData: EMPTY_OBJECT
}

const warnCitationReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        //  GET VEHICLE LIST DETAILS
        case CONSTANTS.GET_WARNING_DETAIL_REQUEST:
            return {
                ...state,
                loader: true,
                errorMessage: ''
            }
        case CONSTANTS.GET_WARNING_DETAIL_SUCCESS:
            return {
                ...state,
                loader: false,
                warnCitationDetail: action.data,
                hasError: false,
                errorMessage: ''
            }
        case CONSTANTS.GET_WARNING_DETAIL_FAILURE:
            return {
                ...state,
                loader: false,
                errorMessage: 'There is some Error'
            }
        case CONSTANTS.GET_RATE_FACILITY_REQUEST:
            return {
                ...state,
                loader: true,
                errorMessage: ''
            }
        case CONSTANTS.GET_RATE_FACILITY_SUCCESS:
            return {
                ...state,
                loader: false,
                facilityData: action.data,
                hasError: false,
                errorMessage: ''
            }
        case CONSTANTS.GET_RATE_FACILITY_FAILURE:
            return {
                ...state,
                loader: false,
                errorMessage: 'There is some Error'
            }

        default:
            return state
    }
}

export default warnCitationReducer
